var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1825 90H12.1825V81.93C8.795 81.4425 6.1825 78.5225 6.1825 75V73C6.1825 69.14 9.3225 66 13.1825 66H15.1825V72H13.1825C12.63 72 12.1825 72.4475 12.1825 73V75C12.1825 75.5525 12.63 76 13.1825 76H18.1825V84H28.1825V90Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1825 90H87.1825V84H98.1825C98.735 84 99.1825 83.5525 99.1825 83V57.75L89.305 39.2625L89.245 39.1175C88.475 37.2225 86.6575 36 84.6125 36H23.1825C20.425 36 18.1825 38.2425 18.1825 41V63H12.1825V41C12.1825 34.935 17.1175 30 23.1825 30H84.6125C89.055 30 93.01 32.625 94.74 36.705L105.182 56.25V83C105.182 86.86 102.042 90 98.1825 90Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1825 84H45.1825V90H69.1825V84Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.182 54H18V60H101.182V54Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 36H39V72H45V36Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3209 31.8041L70.8181 34.1956L81.2482 58.1946L86.751 55.8031L76.3209 31.8041Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1825 66H15.1825V72H24.1825V66Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36H60V81H66V36Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66H69V72H78V66Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1825 99C29.565 99 24.1825 93.6175 24.1825 87C24.1825 80.3825 29.565 75 36.1825 75C42.8 75 48.1825 80.3825 48.1825 87C48.1825 93.6175 42.8 99 36.1825 99ZM36.1825 81C32.875 81 30.1825 83.6925 30.1825 87C30.1825 90.3075 32.875 93 36.1825 93C39.49 93 42.1825 90.3075 42.1825 87C42.1825 83.6925 39.49 81 36.1825 81Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1825 99C71.565 99 66.1825 93.6175 66.1825 87C66.1825 80.3825 71.565 75 78.1825 75C84.8 75 90.1825 80.3825 90.1825 87C90.1825 93.6175 84.8 99 78.1825 99ZM78.1825 81C74.875 81 72.1825 83.6925 72.1825 87C72.1825 90.3075 74.875 93 78.1825 93C81.49 93 84.1825 90.3075 84.1825 87C84.1825 83.6925 81.49 81 78.1825 81Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/Van.19927ed2.svg";
export { ForwardRef as ReactComponent };